import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as FeedStructureGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general";
import { Route as FeedStructureStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/"
)({
    component: FeedStructureDetailPage,
    staticData: {
        permissions: [
            PermissionEnum.ToolStructureFeedGeneral,
            PermissionEnum.ToolStructureFeedStructure,
        ],
        showInSideMenu: false,
        label: "pages.tool.structure.feed.title",
        redirects: [FeedStructureGeneralPage, FeedStructureStructurePage],
        defaultRedirect: FeedStructureGeneralPage,
    },
});

function FeedStructureDetailPage() {
    return <RedirectPage />;
}
